/** Shared by the Drive Backups list and its per-connection detail. */

export interface BackupRow {
  userId: string;
  name?: string;
  email?: string;
  status: string;
  accountEmail?: string;
  connectedAt: string;
  lastSweepAt?: string;
  lastDeliveredAt?: string;
  deliveredCount: number;
  problem?: string;
  stalled: boolean;
}

/** Sorts and filters key off this, so the three states a reader cares about are
 *  named once rather than re-derived per column. */
export function stateOf(row: BackupRow): 'active' | 'stalled' | 'paused' | 'disconnected' {
  if (row.status === 'paused') return 'paused';
  if (row.status === 'disconnected') return 'disconnected';
  return row.stalled ? 'stalled' : 'active';
}

export function formatWhen(iso?: string): string {
  // "Never" reads better than an empty cell — a backup that has delivered
  // nothing is a fact, not missing data.
  if (!iso) return 'Never';
  return new Date(iso).toLocaleString();
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
